import { useEffect, useState } from 'react';
import { api } from '../../shared/api/client';

const liveCache = new Map<string, Promise<boolean>>();

/**
 * ¿La iglesia tiene algo para «Iglesia en vivo» (canal, página o videos)? Se pregunta una vez por iglesia.
 * Mientras no se sabe, se oculta: así no aparece y desaparece una opción vacía.
 */
export function useLiveConfigured(churchId: string | null, enabled: boolean): boolean {
  const [configured, setConfigured] = useState(false);
  useEffect(() => {
    setConfigured(false);
    if (!churchId || !enabled) return;
    let alive = true;
    if (!liveCache.has(churchId)) {
      liveCache.set(
        churchId,
        api
          .get<{ configured?: boolean }>(`/multichurch/churches/${churchId}/live`)
          .then((r) => r.configured === true)
          .catch(() => {
            liveCache.delete(churchId);
            return false;
          }),
      );
    }
    void liveCache.get(churchId)!.then((v) => alive && setConfigured(v));
    return () => {
      alive = false;
    };
  }, [churchId, enabled]);
  return configured;
}

/** Para pruebas: olvida lo consultado. */
export const resetMenuData = () => liveCache.clear();
